import { RailTrackTypeEnum } from 'CoreAPI/Components/RailTrackTypeEnum';

const STOP_BAR_2_TRACKS_PRODUCT_REF = '00513236';
const STOP_BAR_3_TRACKS_PRODUCT_REF = '80513237';

export const STOP_BAR_WIDTH = 18;
export const STOP_BAR_HEIGHT = 2400;

export const getStopBarProductRef = (railTrackType: RailTrackTypeEnum) => {
  switch (railTrackType) {
    case RailTrackTypeEnum.TwoTrack:
      return STOP_BAR_2_TRACKS_PRODUCT_REF;
    case RailTrackTypeEnum.ThreeTrack:
      return STOP_BAR_3_TRACKS_PRODUCT_REF;
    default:
      throw Error(`${railTrackType} not implemented`);
  }
};
